import Vehile from "../images/categoryimage/vehile.png";
import Property from "../images/categoryimage/house.png";
import Other from "../images/categoryimage/others.png";
import Jobs from "../images/categoryimage/job.png";
import Services from "../images/categoryimage/service.png";
import Agriculture from "../images/categoryimage/agriculture.png";
import Education from "../images/categoryimage/education.png";
import Electronics from "../images/categoryimage/electronic.png";
import Essentials from "../images/categoryimage/essentisial.png";
import Fashion from "../images/categoryimage/makeup.png";
import Hobby from "../images/categoryimage/hobby.png";
import Garden from "../images/categoryimage/garden.png";

const categories = [
  { _id: 1, Category: "Vehicles", image: Vehile },
  { _id: 2, Category: "Property", image: Property },
  { _id: 4, Category: "Jobs", image: Jobs },
  { _id: 5, Category: "Services", image: Services },
  { _id: 6, Category: "Agriculture", image: Agriculture },
  { _id: 7, Category: "Education", image: Education },
  { _id: 8, Category: "Electronics", image: Electronics },
  { _id: 9, Category: "Essentials", image: Essentials },
  { _id: 10, Category: "Beauty", image: Fashion },
  { _id: 11, Category: "Hobby", image: Hobby },
  { _id: 12, Category: "Garden", image: Garden },
  { _id: 3, Category: "Others", image: Other },
];

export default categories;
